import { ApiService } from "@/api";

export default {
  UPDATE_SIP_SERVER(context, { id, data }) {
    return ApiService.sip_servers.update(id, data);
  },
  GET_SIP_SERVER({ commit }, id) {
    return ApiService.sip_servers.get(id).then((sip_server) => commit("SET_SIP_SERVER", sip_server));
  },
  ADD_SIP_SERVER(context, newSipServer) {
    return ApiService.sip_servers.create(newSipServer).then((data) => data.id_sip_server);
  },
  DELETE_SIP_SERVER(context, id) {
    return ApiService.sip_servers.delete(id);
  },
};
